import { useState, useEffect } from 'react'
import { useParams } from 'react-router'
import { useLocal } from 'hooks/useLocal'
import useRouter from 'utils/useRouter'

export const useEditarLocal = (props) => {
  const { route } = props
  const localService = useLocal()
  const params = useParams()
  const router = useRouter()

  const [local, setLocal] = useState({})
  const [carregandoLocal, setCarregandoLocal] = useState(false)


  useEffect(() => {
    if (route.editar && params.id) {
      localService.listarLocal(params.id, setLocal, setCarregandoLocal)
    }
  }, [route.editar, params.id])

  return {
    local,
    carregandoLocal,
    idCaso: params.idCaso,
    route,
    router,
  }
}
